import script from "./SelectMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectMenu.vue?vue&type=script&setup=true&lang=js"

import "./SelectMenu.vue?vue&type=style&index=0&id=0728f50a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0728f50a"]])

export default __exports__